import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class GrupoService {

public grupoSeleccionado: any;

  constructor() { }

  addGrupo(){
    return gql`
      mutation createAgrupacion($input: createAgrupacionInput!) {
        createAgrupacion(input: $input) {
          agrupacion {
            id
         }
        }
      }
    `;
  }

  addCampo(){
    return gql`
      mutation createCampo($input: createCampoInput!) {
        createCampo(input: $input) {
          campo {
            id
         }
        }
      }
    `;
  }

  getGrupoById(){
    return gql`
      query getAgrupacionById($id: ID!) {
          agrupacion(id: $id) {
            id
            nombre
            cliente {
              id
            }
            campos {
              id
              nombre
              instalacions {
                id
                nombre
              } 
            }           
          }
        }
    `;
  }

  getGruposByCliente(){
    return gql`
      query getAgrupacionesByCliente($id: ID!){
        cliente(id: $id){
          agrupacions {
            id
            nombre
            campos {
              id
              nombre
              instalacions {
                id
                nombre
              }
            }
          }
        }
      }
    `;
  }

  updateGrupo(){
    return gql`
      mutation updateAgrupacion($input: updateAgrupacionInput!) {
        updateAgrupacion(input: $input) {
          agrupacion {
            id
            
          }
        }
      }
    `;
  }

  deleteGrupo(){
    return gql`
      mutation deleteAgrupacion($input: deleteAgrupacionInput!) {
        deleteAgrupacion(input: $input) {
          agrupacion {
            id
          }
        }
      }
    `;
  }

  deleteCampo(){
    return gql`
      mutation deleteCampo($input: deleteCampoInput!) {
        deleteCampo(input: $input) {
          campo {
            id
          }
        }
      }
    `;
  }

  getInstalacionesByCampo(){
    return gql`
      query getInstalacionesByCampo($id: ID!){
        campo(id: $id){
            id
            instalacions {
              id 
              nombre
            
          }
        }
      }
    `;
  }

  getCamposByGrupo(){
    return gql`
      query getCamposByGrupo($id: ID!){
        agrupacion(id: $id){
            id
            nombre
            campos {
              id 
              nombre
              instalacions {
                id
                nombre
              }
              agrupacion{
                id
                nombre
              }
          }
        }
      }
    `;
  }

  updateInstalacionesByCampo(){
    return gql`
      mutation updateCampo($input: updateCampoInput!) {
        updateCampo(input: $input) {
          campo{
            id
            instalacions{
              id
            }
            
          }
        }
      }
    `;
  }

  updateCampo(){
    return gql`
      mutation updateCampo($input: updateCampoInput!) {
        updateCampo(input: $input) {
          campo{
            id
            instalacions{
              id
            }
            
          }
        }
      }
    `;
  }

  

setGrupoSeleccionado(grupo:any){
this.grupoSeleccionado = grupo;
}

clearGrupo(){
  this.grupoSeleccionado = undefined;
}

getGrupoSeleccionado(){
  const temp = this.grupoSeleccionado;
  this.clearGrupo()
  return temp;
}

}
